import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { getPoliciesOperation } from './policies-operations';
import { PoliciesState } from './PoliciesTypes';

export const initialState: PoliciesState = {
  companies: [],
  loading: false,
  error: null,
};

const policiesSlice = createSlice({
  name: 'policies',
  initialState,
  reducers: {
    clearPoliciesError: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(getPoliciesOperation.fulfilled, (state, { payload }) => {
      state.companies = payload;
      state.loading = false;
      state.error = null;
    });

    builder.addMatcher(isAnyOf(getPoliciesOperation.pending), state => {
      state.loading = true;
      state.error = null;
    });

    builder.addMatcher(isAnyOf(getPoliciesOperation.rejected), (state, { payload, error }) => {
      state.loading = false;
      state.error = (payload as any)?.message || error.message || null;
    });

    builder.addMatcher(isAnyOf(getPoliciesOperation.fulfilled), state => {
      state.loading = false;
    });
  },
});

export const { clearPoliciesError } = policiesSlice.actions;
export default policiesSlice.reducer;
